/* eslint-disable no-restricted-imports */
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { v4 as uuidv4 } from "uuid";
import { toAbsoluteUrl } from "../../_metronic/_helpers";

import { getOrgListData } from "../modules/Auth/_redux/adminCrud";

export function OrgList({ onClick, onInit, useAnonymous }) {
  const useStyles = makeStyles(theme => ({
    treeContainerStyle: {
      display: "inline-block",
      width: "calc(30% - 12px)",
      border: "1px solid #c8cace",
      borderRadius: "4px 4px 4px 4px",
      marginRight: "12px",
      verticalAlign: "top"
    },
    listContainerStyle: {
      display: "inline-block",
      width: "70%",
      border: "1px solid #c8cace",
      borderRadius: "4px 4px 4px 4px"
    },
    inputStyle: {
      display: "inline-flex",
      width: "200px",
      height: "32px",
      border: "1px solid #c8cace",
      paddingLeft: "8px",
      borderRadius: "2px 2px 2px 2px",
      ":active": {
        border: "1px solid #c8cace"
      }
    },
    buttonStyle: {
      width: "120px",
      height: "32px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1.2rem",
      marginRight: "12px"
    },
    buttonSmallStyle: {
      width: "60px",
      height: "28px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1rem"
      //   marginLeft: "12px"
    },

    buttonDisableStyle: {
      color: "#b4b5b8",
      border: "1px solid #b4b5b8",
      background: "#ebedf1"
    },
    buttonClearStyle: {
      width: "32px",
      height: "32px",
      border: "0px solid #123456",
      marginRight: "12px",
      "&:hover": {
        backgroundColor: "transparent !important"
      }
    },
    searchStyle: {
      width: "120px",
      height: "32px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1rem",
      float: "right"
    },
    dateStyle: {
      width: "160px",
      height: "32px",
      color: "#123456",
      border: "1px solid #c8cace",
      fontSize: "1rem",
      marginRight: "36px",
      textAlign: "left",
      background: "transparent",
      borderRadius: "4px 4px 4px 4px",
      paddingLeft: "12px"
    },

    boxContainer: {
      display: "inline-block",
      width: "100%",
      verticalAlign: "top"
    },
    box30Style: {
      width: "100%",
      display: "inline-block",
      background: "white",
      border: "1px solid lightgray",
      padding: "24px",
      marginBottom: "12px"
    },
    boxStyle: {
      width: "100%",
      display: "inline-block",
      background: "white",
      border: "1px solid lightgray",
      padding: "24px",
      marginBottom: "12px"
    },
    subTitleStyle: {
      display: "block",
      fontSize: "1rem",
      width: "100%",
      marginBottom: "12px",
      fontWeight: "bold",
      alignItems: "baseline",
      color: "#555555"
    },
    subTitleInnerStyle: {
      display: "block",
      fontSize: "1rem",
      width: "100%",
      margin: "12px",
      fontWeight: "bold",
      alignItems: "baseline",
      color: "#555555"
    },
    headerRowStyle: {
      display: "flex",
      textAlign: "center",
      height: "44px",
      lineHeight: "44px"
    },
    headerColStyle: {
      display: "inline-block",
      fontSize: "1rem",
      fontWeight: "bold",
      textAlign: "center",
      width: "50%",
      background: "#dfe2e8",
      height: "44px"
    },
    headerCol100Style: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "100%",
      background: "#dfe2e8",
      height: "44px"
    },
    headerCheckboxStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "44px",
      background: "#dfe2e8",
      height: "44px"
    },
    dataCheckboxStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "44px",
      //   background: "#dfe2e8",
      height: "44px"
    },
    dataRowStyle: {
      display: "flex",
      textAlign: "center",
      height: "44px",
      lineHeight: "44px",
      borderBottom: "1px solid lightgray"
    },
    width100Style: {
      width: "100%"
    },
    dataColStyle: {
      display: "inline-block",
      fontSize: "1rem",
      textAlign: "center",
      width: "50%",
      height: "44px"
    },
    dataCol100Style: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "100%",
      height: "44px"
    },
    dataColSmallStyle: {
      display: "inline-block",
      fontSize: "12px",
      textAlign: "center",
      width: "50%",
      height: "44px",
      overflow: "hidden",
      lineHeight: "16px",
      paddingTop: "6px"
    },
    dataColTextStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "left",
      //   width: "50%",
      height: "44px"
    },
    radioStyle: {
      width: "80px",
      fontSize: "1rem",
      //   background: "transparent",
      color: "#555555",
      borderColor: "#dfe2e8",
      //   paddingTop: "6px",
      //   "&:hover": {
      //     color: "#123456",
      //     backgroundColor: "#eae4f5 !important"
      //   },
      "&:active": {
        color: "white",
        backgroundColor: "#123456 !important"
      }
    },
    selected: {
      color: "white",
      backgroundColor: "#123456 !important"
    }
  }));

  const [orgList, setOrgList] = useState([]);

  const Styles = useStyles();
  const [refresh, setRefresh] = React.useState(false);

  const anonymousDept = {
    deptCode: 77777,
    deptName: '미분류',
  }

  const pollOrgList = () => {
    getOrgListData().then(data => {
      console.log("getOrgListData", data);

      /*
      orgData.data.orgs 
      createDt: "2021-10-08T07:06:23.000Z"
      deptCode: "A01.D1523"
      deptLevel: "2"
      deptName: "CEO"
      lcId: "ko_KR"
      orgCode: "ORG02"
      parentDeptCode: "A01.D1522"
      updateDt: "2021-10-08T07:06:23.000Z"
      */

      data.data.orgs.map(org => (org.expanded = true));

      let orgData = data.data.orgs.filter(org => org.deptLevel === "1");

      let level2 = data.data.orgs.filter(org => org.deptLevel === "2");
      level2.forEach(dept => {
        orgData.forEach(org => {
          if (dept.parentDeptCode === org.deptCode) {
            if (org.subList == null) org.subList = [dept];
            else org.subList.push(dept);
          }
        });
      });

      let level3 = data.data.orgs.filter(org => org.deptLevel === "3");
      level3.forEach(dept => {
        level2.forEach(org => {
          if (dept.parentDeptCode === org.deptCode) {
            if (org.subList == null) org.subList = [dept];
            else org.subList.push(dept);
          }
        });
      });

      console.log("NEW ORG LIST", orgData);

      setOrgList(orgData);
      setRefresh(!refresh);
      if (onInit !== undefined) onInit(orgData[0]);
    })
    .catch(error => {
      console.log(error)
    })
  };

  const unselect = item => {
    if (item == null) item = orgList[0];
    if(item == null) return

    item.selected = false;
    if (item.subList != null && item.subList.length > 0)
      item.subList.map(sub => unselect(sub));
  };

  const toggle = item => {
    item.expanded = !item.expanded;
    if (item.subList == null || item.subList.length === 0)
      item.selected = !item.selected;

    setRefresh(!refresh);
  };

  const renderOrgItem = (depart, depth, index) => (
    <div key={uuidv4()}>
      <div
        key={uuidv4()}
        style={{
          height: "32px",
          lineHeight: "32px",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          overflow: "auto",
          fontWeight: `${depth === 0 ? "bold" : "unset"}`,
          paddingLeft: `${depth * 18 + 8}px`,
          background: `${depart.selected === true ? "#f1f3f6" : "unset"}`
        }}
        onClick={() => {
          unselect(null);
          toggle(depart);
          if (onClick !== undefined) onClick(depart);
        }}
      >
        <img
          src={toAbsoluteUrl(
            depart.subList == null || depart.subList.length === 0
              ? "/media/images/icon_address_arrow_right.svg"
              : depart.expanded
              ? "/media/images/icon_arrow_down.svg"
              : "/media/images/icon_arrow_up.svg"
          )}
          alt=""
        />
        &nbsp;&nbsp;{depart.deptName}
      </div>
      {depart.expanded &&
        depart.subList?.length > 0 &&
        depart.subList.map(sub => renderOrgItem(sub, depth + 1, 0))}
    </div>
  );

  useEffect(() => {
    pollOrgList();
  }, []);

  useEffect(() => {}, [refresh]);

  return (
    <>
      <div
        style={{
          marginTop: "12px",
          // marginLeft: "-12px",
          height: "100%"
        }}
      >
        {/* -------------------- */}

        {/* <div className={Styles.boxContainer}> */}
        {/* <div className={Styles.treeContainerStyle}> */}
        <div className={Styles.subTitleInnerStyle}>조직도</div>
        <div
          className={Styles.popInputLongStyle}
          style={{
            marginTop: "0px",
            //   borderRadius: "4px 4px 4px 4px",
            borderTop: "1px solid lightgray",
            height: "640px",
            overflow: "scroll"
          }}
          key={uuidv4()}
        >
          {orgList.map((depart, index) => renderOrgItem(depart, 0, index))}
          {renderOrgItem(anonymousDept, 0, 0)}
        </div>
      </div>
      {/* </div> */}
      {/* </div> */}
    </>
  );
}
